<template>
  <v-tooltip
    v-model="isOpen"
    :open-on-hover="!isMobile"
    :open-on-click="false"
    :open-on-focus="false"
    bottom
  >
    <template #activator="{ on, attrs }">
      <span
        v-click-outside="onClickOutside"
        v-bind="attrs"
        :data-qa="qa"
        class="lpu-license-badge d-inline-flex align-center justify-center ml-1 cursor-pointer"
        role="button"
        tabindex="0"
        :aria-label="text"
        v-on="isMobile ? {} : on"
        @click.stop="onBadgeClick"
      >
        <v-icon
          color="success"
          size="18"
          class="lpu-license-badge__icon"
        >
          ui-icon-shield-checkmark-40
        </v-icon>
      </span>
    </template>
    <div class="text-body-1 bg-gray-0--text">
      {{ text }}
    </div>
  </v-tooltip>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useContextStore } from 'src/store'
import type { ContextStore } from 'src/components/pages/info/legal-case/types'

defineProps<{
  text: string
  qa: string
}>()

const { context }: ContextStore = useContextStore()
const isMobile = context.flavour === 'mobile'
const isOpen = ref(false)

const onBadgeClick = () => {
  if (!isMobile) {
    return
  }

  isOpen.value = !isOpen.value
}

const onClickOutside = () => {
  if (!isMobile || !isOpen.value) {
    return
  }

  isOpen.value = false
}
</script>

<style lang="scss" scoped>
.lpu-license-badge {
  vertical-align: middle;

  &__icon {
    pointer-events: none;
  }
}
</style>
